<template>
    <div class="voucher">
        <div class="container">
            <ul class="breadcrumb d-print-none">
                <li class="breadcrumb-item">
                    <router-link :to="{name: 'Home'}">Página Principal</router-link>
                </li>
                <li class="breadcrumb-item">
                    <span>Pagamento</span>
                </li>
            </ul>
            <div class="d-none d-print-block">
                <div class="row mt-4">
                    <div class="col-print-3 col-md-3 col-2">
                        <img src="@/img/brand-drachei-big.svg" alt="" class="img-fluid">
                    </div>
                    <div class="col-print-1 col-md-1 offset-7">
                        <img src="@/img/drachei-card.png" alt="" class="img-fluid pt-3">

                    </div>
                    <div class="col-print-1 col-1">
                        <img src="@/img/grupo-sin.png" alt="" class="img-fluid" width="200px" height="180px">
                    </div>
                </div>
                <hr>
            </div>
            <div class="" v-if="pedido">
                <div class="row">
                    <div class="col-md-9 col-sm-12 element-box">
                        <div class="row">
                            <div class="col-md-9 col-sm-8">
                                <div class="element-wrapper pb-2 ">
                                    <h3 v-if="pedido.pagamentoAto" class="text-success"><i class="fas fa-check-circle"></i> Solicitação Confirmada</h3>
                                    <h3 v-else-if="pedido.statusPagamento === 'CONCLUIDO'" class="text-success"><i class="fas fa-check-circle"></i> Compra Confirmada</h3>
                                    <h3 v-else class="text-warning"><i class="fas fa-check-circle"></i> Aguardando Pagamento</h3>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-4">
                                <div class="element-wrapper pb-2 text-right">
                                    <label>Número Pedido</label>
                                    <h4 class="text-info">{{pedido.codigo}}</h4>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="pedido.statusPagamento === 'AGUARDANDO_PAGAMENTO'">
                            <div class="col">
                                <div class="element-wrapper pb-2 text-right">
                                    <a target="_blank" :href="pedido.linkBoleto" class="btn btn-warning">
                                        <i class="fa fa-file-pdf"></i>
                                        Imprimir Boleto
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="element-wrapper">
                                    <h5 class="element-header">
                                        Cliente
                                    </h5>
                                    <div class="row">
                                        <div class="col">
                                            <div class="label">Nome</div>
                                            <h6>{{pedido.cliente.name}}</h6>
                                        </div>
                                        <div class="col">
                                            <div class="label">CPF</div>
                                            <h6>{{pedido.cliente.cpf}}</h6>
                                        </div>
                                        <div class="col" v-if="user.cartao">
                                            <div class="label">Nº Dr.Achei Card</div>
                                            <h6>{{user.cartao.numeroCartao}}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="element-wrapper" v-if="pedido.dependente">
                                    <h5 class="element-header">
                                        Atendimento para o Dependente
                                    </h5>
                                    <div class="row">
                                        <div class="col">
                                            <div class="label">Nome</div>
                                            <h6>{{pedido.dependente.name || pedido.dependente.NomeDepedente}}</h6>
                                        </div>
                                        <div class="col">
                                            <div class="label">CPF</div>
                                            <h6>{{pedido.dependente.cpf || pedido.dependente.CPF_Depedente}}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="element-wrapper">
                                    <div class="row">
                                        <div class="col">
                                            <h5 class="element-header">
                                                Local de Atendimento
                                            </h5>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3 text-center">
                                            <img :src="url" class="img-fluid" width="200px" height="200px" alt="Laboratorio" :onerror="`this.src='${require('@/img/icon-drachei-alpha.svg')}'`">
                                            <!--<div class="rating">
                                                <rate :length="5" :value="pedido.unidade.rate" :disabled="true" ></rate>
                                            </div>-->
                                        </div>
                                        <div class="col-md-5 col-12">
                                            <div class="data">
                                                <label for="">Local</label>
                                                <h5>{{pedido.unidade.nomeRede}}</h5>
                                                <p>{{endereco(pedido.unidade)}}</p>
                                                <a href="#" class="d-print-none"><i data-v-02e3ae44="" class="ti-location-pin"></i> Ver no mapa</a>
                                            </div>
                                        </div>
                                        <div class="col-md-2">

                                            <label for="">Telefone</label>
                                            <h6>{{pedido.unidade.telefoneFixo}}</h6>
                                        </div>
                                        <div class="col-md-3 text-center"  v-if="pedido.agendamento && pedido.agendamento.horarioEscolhido">
                                            <div class="alert border border-info">
                                                <i class="os-icon os-icon-calendar-time"></i> <label for="">Agendado para:</label>
                                                <h5>{{pedido.agendamento.dataEscolhida}}</h5>
                                                <h5>{{pedido.agendamento.horarioEscolhido.horario}}</h5>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="element-wrapper">
                                    <h6 class="element-header">
                                        Detalhes do Pedido
                                    </h6>
                                    <div class="invoice-body">
                                        <div class="invoice-desc">
                                            <div class="label">
                                                Forma de Pagamento
                                            </div>
                                            <div class="desc-value">
                                                {{pedido.pagamentoAto ? 'No Local de atendimento' : 'Plataforma'}}
                                            </div>

                                        </div>
                                        <div class="invoice-table alert alert-warning borderless">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th>
                                                Descrição
                                                </th>

                                                <th class="text-right">
                                                Valor
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-if="isConsulta">
                                                <td>
                                                Consulta {{pedido.consulta.especialidade.nome}}
                                                </td>

                                                <td class="text-right">
                                                {{pedido.valorTotal | money}}
                                                </td>
                                            </tr>
                                            <tr v-if="isExame"
                                                v-for="exame in exames" :key="exame._id">
                                                <td>
                                                {{exame.nomeExame}}
                                                </td>

                                                <td class="text-right">
                                                {{getValor(exame) | money}}
                                                </td>
                                            </tr>
                                            <tr v-if="pedido.cupom">
                                                <td>
                                                    <div class="value">
                                                        CUPOM
                                                    </div>
                                                    <small class="sub-value">{{pedido.cupom.name}}</small>
                                                </td>
                                                <td class="text-right">-{{pedido.cupom.descontoCliente | money}}</td>
                                            </tr>
                                            </tbody>
                                            <tfoot>
                                            <tr>
                                                <td>
                                                Total
                                                </td>
                                                <td class="text-right">
                                                {{ pedido.valorTotal | money}} <span v-if="pedido.voucher && pedido.voucher.email_content && pedido.voucher.email_content.isParcelado">({{ pedido.voucher.email_content.numeroParcelas }}x de R$ {{ pedido.voucher.email_content.valorParcelado }})</span>
                                                </td>
                                            </tr>
                                            </tfoot>
                                        </table>
                                        <div class="terms">
                                            <div class="terms-header">
                                            Observações
                                            </div>
                                            <div class="terms-content">
                                            Para realização exames, é necessário levar pedido médico no dia do exame.
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="invoice-footer">
                            <div class="invoice-logo">
                               <span>Dr.Achei</span>
                            </div>
                            <div class="invoice-info">
                                <span>contato@drachei.com.br</span><span>21 2263-9325</span>
                            </div>
                        </div>
                    </div>
                    <div class="col offset-1 text-right d-print-none">
                        <div><a class="btn btn-primary mb-3" href="javascript:window.print()"><i class="os-icon os-icon-newspaper"></i><span>Imprimir</span></a></div>
                        <a v-if="!pedido.pagamentoAto" class="btn btn-primary" href="#" @click="reenviar()"><i class="os-icon os-icon-email-forward"></i><span>Reenviar por e-mail</span></a>
                        <hr>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as http from 'axios'
import moment from 'moment'
const defaultEndpoint = require('@/endpoint')

export default {
  created () {
    moment.locale('pt-br')
    let id = this.$route.query.id
    this.$store.dispatch('setLoading', true)
    http.get(`/pedidos/${id}?populate=cliente unidade cupom`)
      .then(response => {
        this.$store.dispatch('setLoading', false)
        this.pedido = response.data
        this.url = `${http.defaults.baseURL}/redeImagemLogo?q=${this.pedido.unidade.nomeRede}`
        if (this.pedido.exames) {
          this.subTotalDrAchei = this.pedido.exames.map(exame => exame.valorDrAchei).reduce((a, value) => a + value, 0)
          this.subTotalSinSaude = this.pedido.exames.map(exame => exame.valorSinSaude).reduce((a, value) => a + value, 0)
          this.subTotalParticular = this.pedido.exames.map(exame => exame.valorParticular).reduce((a, value) => a + value, 0)
        }
      })
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    isConsulta () {
      return this.pedido && this.pedido.consulta
    },

    isExame () {
      return this.pedido && this.pedido.exames && this.pedido.exames.length > 0
    },
    exames () {
      return this.pedido ? this.pedido.exames : []
    },
    subTotalExameTipoPagamento () {
      return this.pedido.tipoPagamento === 'Drachei' ? this.subTotalDrAchei : this.subTotalSinSaude
    }
  },
  data () {
    return {
      pedido: null,
      subTotalParticular: 0,
      subTotalDrAchei: 0,
      subTotalSinSaude: 0,
      url: null
    }
  },
  methods: {
    endereco (unidade) {
      return `${unidade.localAtendimento}, numero ${unidade.numero}, ${unidade.bairro}, ${unidade.cidade} - ${unidade.uf}`
    },
    getDataFormatada (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    getValor (exame) {
      return this.pedido.tipoPagamento === 'Drachei' ? exame.valorDrAchei : exame.valorSinSaude
    },
    async reenviar () {
      this.$store.dispatch('setLoading', true)
      await http.get(`${defaultEndpoint.urlPayment}/api/v1/vouchers/send/${this.pedido._id}`)
      this.$store.dispatch('setLoading', false)
      this.$store.dispatch('showSuccessMsg', {body: 'Vocuher reenviado com sucesso para o seu email!'})
    }
  }
}
</script>
<style scoped>
@media print {
  .row {
    display: flex !important;
    flex-wrap: wrap !important;
    margin-right: -15px !important;
    margin-left: -15px !important;
  }

  [class*="col-"] {
    position: relative !important;
    padding-right: 15px !important;
    padding-left: 15px !important;
  }

  /* ----- col- (para impressão) ----- */
  .col-1  { flex: 0 0 8.333%;  max-width: 8.333%; }
  .col-2  { flex: 0 0 16.666%; max-width: 16.666%; }
  .col-3  { flex: 0 0 25%;     max-width: 25%; }
  .col-4  { flex: 0 0 33.333%; max-width: 33.333%; }
  .col-5  { flex: 0 0 41.666%; max-width: 41.666%; }

  /* ----- col-md- (para impressão) ----- */
  .col-md-1 { flex: 0 0 8.333%;  max-width: 8.333%; }
  .col-md-2 { flex: 0 0 16.666%; max-width: 16.666%; }
  .col-md-3 { flex: 0 0 25%;     max-width: 25%; }
  .col-md-4 { flex: 0 0 33.333%; max-width: 33.333%; }
  .col-md-5 { flex: 0 0 41.666%; max-width: 41.666%; }

  /* Exemplo de offset */
  .offset-7 { margin-left: 58.333% !important; }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/pagamentos/Voucher.vue